import UIDs from "../../../../UIDs";

const uid = UIDs.screens.chinesepark.roommember;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    DELETE_MEMBER_USERS_ASYNC: `${uid}.deleteMemberUsersAsync`,
    DELETE_MEMBER_USERS_SUCCESS: `${uid}.deleteMemberUsersSuccess`,
    DELETE_MEMBER_USERS_FAILURE: `${uid}.deleteMemberUsersFailure`,
    SET_SELECTED_IDS: `${uid}.setSelectedIds`,
    SEND_NOTIFICATION_ASYNC: `${uid}.sendNotificationAsync`,
    SEND_NOTIFICATION_SUCCESS: `${uid}.sendNotificationSuccess`,
    SEND_NOTIFICATION_FAILURE: `${uid}.sendNotificationFailure`,
    ACTIVATE_ACCOUNT_ASYNC: `${uid}.activateAccountAsync`,
    ACTIVATE_ACCOUNT_SUCCESS: `${uid}.activateAccountSuccess`,
    ACTIVATE_ACCOUNT_FAILURE: `${uid}.activateAccountFailure`,
    SHOW_STUDENT_LINK: `${uid}.showStudentLink`,
};

export { ActionTypes };
